var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("article", { staticClass: "news news--single" }, [
      _c("div", { staticClass: "container-fluid pb-3 pt-3" }, [
        _c("header", { staticClass: "news__header" }, [
          _c("h1", { staticClass: "news__title" }, [
            _vm._v(_vm._s(_vm.newTitle)),
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "news__subtitle mb-0" }, [
            _vm._v(_vm._s(_vm.newSubtitle)),
          ]),
          _vm._v(" "),
          _c(
            "time",
            {
              staticClass: "mt-0",
              attrs: { datetime: _vm.timeSI, pubdate: "" },
            },
            [_vm._v(_vm._s(_vm.timeText))]
          ),
        ]),
        _vm._v(" "),
        _vm.newThumbnail
          ? _c("figure", { staticClass: "news__figure" }, [
              _c("picture", [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: _vm.newThumbnail,
                    loading: "lazy",
                    alt: `Imagem capa da notícia - ${_vm.newTitle}`,
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "news__content ck-content",
          domProps: { innerHTML: _vm._s(_vm.newContent) },
        }),
        _vm._v(" "),
        _vm.newFiles.length > 0
          ? _c(
              "div",
              { staticClass: "news__files" },
              [
                _c("h3", [_vm._v("Ficheiros")]),
                _vm._v(" "),
                _vm._l(_vm.newFiles, function (file, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      staticClass: "news__file",
                      attrs: { target: "_blank", href: file.path },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(file.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }